export default __webpack_public_path__ + "static/media/F0005.eec6b79a.png";